import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
    FontWeight,
    PxSize,
    RemSize,
} from 'shared/design-system/data-access/layout';
import { ColorEnum } from 'shared/design-system/data-access/theme';

@Component({
    selector: 'it-title',
    imports: [NgStyle, NgTemplateOutlet],
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
    @Input() level?: '1' | '2' | '3' | '4' | '5' | '6' = '2';
    @Input() fontSize?: RemSize | PxSize;
    @Input() weight?: FontWeight;
    @Input() color?: ColorEnum;
    @Input() align?: 'center' | 'end';

    get style() {
        return {
            fontSize: this.fontSize,
            fontWeight: this.weight,
            color: this.color,
            textAlign: this.align,
        };
    }
}
